export default __webpack_public_path__ + "static/media/Dr. Jessica Evert, M.D..e51b726b.jpg";